var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pega-print-button-area" }, [
    _c(
      "button",
      {
        staticClass: "boss-button pega-print-button",
        attrs: { "data-test": "print" },
        on: { click: _vm.print },
      },
      [
        _c("img", {
          attrs: { src: require("@/assets/images/icon-print-secondary.svg") },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("印刷")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }